/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';
import { Grid, Box } from '@mui/material';

// export const ToggleButtonStyle = {
//   gap: '8px',
//   display: 'flex',
//   flexDirection: 'row',
//   justifyContent: 'flex-start',
//   alignItems: 'center',
//   padding: '9px 23px',
//   fontSize: '14px',
//   fontFamily: 'Roboto',
//   lineHeight: '20px',
//   textAlign: 'center',
//   whiteSpace: 'nowrap',
//   borderWidth: '1px',
//   overflow: 'hidden',
//   boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.05)',
//   textTransform: 'none',
// };
export const MultipleItemsSelectionComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: #f8fafc;
  box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: ${({ showErrorBorder }) => showErrorBorder && `1px solid ${Palette.Red._300}`};
`;
export const FlexColumn3 = styled.div`
  padding: 16px;
`;

export const SelectedItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ClearBtnSection = styled.div`
  width: 100%;
  height: 48px;
  background: ${Palette.PrimaryGray._000};
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MyBox = styled.div`
  background: ${Palette.PrimaryGray._100};
  width: 100%;
`;

export const MyGrid = styled(Grid)`
  padding: 16px;
  gap: 10px;
`;
